import { useEffect } from "react";
import { motion } from "framer-motion";
import { MapPin, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

const IN = { opacity: 0, scale: 0.92 };
const SHOW = { opacity: 1, scale: 1 };

export function WrongStoreScreen({ storeName, accent, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 15000);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/80 backdrop-blur-sm p-6" data-testid="wrong-store-screen" onClick={onClose}>
      <motion.div initial={IN} animate={SHOW} className="max-w-xl w-full rounded-3xl bg-white text-slate-900 p-8 text-center space-y-4 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="mx-auto h-16 w-16 rounded-full grid place-items-center bg-amber-100 text-amber-600"><MapPin className="h-8 w-8" /></div>
        <h2 className="font-display font-black text-2xl sm:text-3xl">Codice di un altro punto vendita</h2>
        <p className="text-slate-600">Questo codice è valido solo presso</p>
        <p className="font-display font-black text-3xl sm:text-4xl" style={{ color: accent || "#2563eb" }} data-testid="wrong-store-name">{storeName}</p>
        <p className="text-sm text-slate-500">Recati in quel punto vendita per giocarlo, oppure usa un codice ricevuto qui.</p>
        <Button onClick={onClose} className="h-12 px-8 gap-2 text-base" data-testid="wrong-store-close"><RotateCcw className="h-4 w-4" /> Ho capito</Button>
      </motion.div>
    </div>
  );
}
